import ctx from '../../plugins/axios';

// eslint-disable-next-line import/no-anonymous-default-export
export default async (commentObj) => {
  return await ctx.post('/specialty_list/comment', commentObj);
};
